import {
    createContext,
    useContext,
    useCallback,
    useEffect,
    useState,
} from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../settings/constants';
import useAPI from '../../hooks/integrations/useAPI';
import UrlBuilder from '../../utils/UrlBuilder';
import { useAuth } from '../Auth';
import ChartLabel from '../../components/ChartLabel/ChartLabel';

const Context = createContext();

const Provider = ({ children }) => {
    const api = useAPI();
    const auth = useAuth();

    const [defCharts, setDefCharts] = useState([]);
    const [current, setCurrent] = useState(null);

    const [isLoading, setIsLoading] = useState(true);
    const [isCurrentLoading, setIsCurrentLoading] = useState(true);

    const getChart = async (type, uuid, options) => {
        const url = new URL(`${API_BASE_URL}/pip-test-chart`);
        url.searchParams.append('uuid', uuid);
        url.searchParams.append('chart-name', type);
        // this should come as an option?, how to do it according to good practice?
        // TODO
        //const storageKey = `pip-test-chart-${uuid}-${type}`;
        //const cachedData = localStorage.getItem(storageKey);
        //if (cachedData) {
        //return JSON.parse(cachedData);
        //}
        console.info('D3.API_GET : ', url.toString());
        const { data } = await api.makeRequest({ url, method: 'GET' }, options);
        if (data.url) {
            const chart = await axios.get(data.url);
            return chart.data;
        }
        return data;
    };

    const getCurrentChartByType = async (type, options, uuid) => {
        const id = uuid || current?.uuid;
        if (!id || !type) return null;
        return await getChart(type, id, options);
    };

    const getPage = (offset, limit, filters, sorter, options) => {
        const url = new UrlBuilder(`${API_BASE_URL}/pip-tests`);
        url.addPagination(offset, limit).addSorting(sorter);
        if (!filters) {
            console.info('T2.API_GET : ', url.toString());
            return api.makeRequest(
                {
                    url,
                    method: 'GET',
                },
                options
            );
        } else {
            console.info('T3.API_POST: ', url.toString());
            return api.makeRequest(
                {
                    url,
                    method: 'POST',
                    data: JSON.stringify(filters),
                },
                options
            );
        }
    };

    const getDefCharts = useCallback(async () => {
        setIsLoading(true);
        const url = `${API_BASE_URL}/pip-test-chart-params`;
        console.info('D1.API_GET: ', url);
        api.makeRequest({ url: url, method: 'GET' }, false).then(({ data }) => {
            data.forEach((d) => {
                d.value = d.id;
                d.label = <ChartLabel {...d} />;
            });
            setDefCharts(data);
            setIsLoading(false);
        });
    });

    const getFiltersData = useCallback(async () => {
        const url = `${API_BASE_URL}/pip-tests-filters-data`;
        return api
            .makeRequest({ url: url, method: 'GET' })
            .then(({ data }) => data);
    });

    const getTypeById = (id) => {
        return defCharts.find((ch) => {
            return ch.id === id;
        });
    };

    useEffect(() => {
        if (auth.user) getDefCharts().catch((err) => console.error(err));
    }, [auth.user]);

    const getChartsInfo = async (uuid) => {
        const url = new URL(`${API_BASE_URL}/pip-test-results`);
        url.searchParams.append('uuid', uuid);
        //TODO
        //const storageKey = `pip-test-results-${uuid}`;
        //const cachedData = localStorage.getItem(storageKey);
        //if (cachedData) {
        //return JSON.parse(cachedData);
        //}
        console.info('T5.API_GET: ', url.toString());
        return await api
            .makeRequest({ url: url, method: 'GET' })
            .then(({ data }) => {
                //localStorage.setItem(storageKey, JSON.stringify(data));
                return data;
            });
    };

    return (
        <Context.Provider
            value={{
                getPage,
                getCurrentChartByType,
                current,
                defCharts,
                getTypeById,
                getChartsInfo,
                getFiltersData,
                isLoading,
                isCurrentLoading,
                setIsCurrentLoading,
                setCurrent,
            }}
        >
            {children}
        </Context.Provider>
    );
};

export const usePipTestCtx = () => {
    return useContext(Context);
};

export default Provider;
